// Module
var code = "<template><require from=\"../../../../../components/check-box/check-box\"></require><div class=\"column\"><check-box class=\"margin-bottom col-xs-gutter\" value=\"Buttons rounded\" checked.two-way=\"model.buttons.rounded\"></check-box></div></template>";
// Exports
module.exports = code;